import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShipmentPartnerManagementRoutingModule } from './shipment-partner-management-routing.module';
import { DeliveryShipmentToPartnerComponent } from './delivery-shipment-to-partner/delivery-shipment-to-partner.component';
import { SharedModule } from '../../shared/shared.module';
import { LayoutModule } from '../layout/layout.module';
import { AutoCompleteModule, CalendarModule, DropdownModule } from 'primeng/primeng';
import { FormsModule } from '@angular/forms';
import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';
import { AgmCoreConfig } from '../../infrastructure/agmCore.config';
import { CompartmentsService, DistrictService, HubService, ShipmentService, StreetService, TPLService, TruckService, WardService } from '../../services';
import { TableModule } from 'primeng/table';
import { VehicleServices } from '../../services/vehicle.services';
import { ListShipmentToPartnerComponent } from './list-shipment-to-partner/list-shipment-to-partner.component';

@NgModule({
  declarations: [DeliveryShipmentToPartnerComponent, ListShipmentToPartnerComponent],
  imports: [
    CommonModule,
    FormsModule,
    ShipmentPartnerManagementRoutingModule,
    SharedModule,
    LayoutModule,
    DropdownModule,
    TableModule,
    CalendarModule,
    AutoCompleteModule,
    AgmCoreModule.forRoot(AgmCoreConfig)
  ],
  providers:[
    // GoogleMapsAPIWrapper
    TPLService,
    TruckService,
    CompartmentsService,
    ShipmentService,
    HubService,
    DistrictService,
    WardService,
    VehicleServices,
    StreetService
  ]
})
export class ShipmentPartnerManagementModule { }
